import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import {
  manualLocationChosen,
  manualLocationClear,
} from '#/shared/queries/location';
import { locationToPosition } from '#/shared/utils/location';
import {
  selectCurrentLocation,
  selectCurrentPosition,
} from '#/shared/slices/location';

export default () => {
  const dispatch = useDispatch();
  const currentLocation = useSelector(selectCurrentLocation, shallowEqual);
  const currentPosition = useSelector(selectCurrentPosition, shallowEqual);
  const { isManualLocation } = useSelector(s => s.shared.location);

  const dispatchManualLocationChosen = useCallback(
    (lat, lng) => dispatch(manualLocationChosen({ lat, lng })),
    [dispatch]
  );

  const dispatchClearManualLocation = useCallback(() => {
    dispatch(manualLocationClear());
  }, [dispatch]);

  // this object merges location and (geolocation) position info into
  // a position object format; for use in components that support only
  // position, but need to draw upon both current location values
  const currentLocationPosition = useMemo(
    () => ({
      ...currentPosition,
      coords:
        currentPosition.coords || currentLocation
          ? locationToPosition(currentLocation).coords
          : null,
      error: isManualLocation && currentLocation ? null : currentPosition.error,
    }),
    [currentLocation, currentPosition, isManualLocation]
  );

  const intl = useIntl();

  return {
    currentLocation: useMemo(
      () =>
        currentLocation && {
          ...currentLocation,
          name:
            currentLocation?.name ||
            `(${intl.formatMessage({ id: 'planner.current-location-label' })})`,
        },
      [currentLocation, intl]
    ),
    manualLocationChosen: dispatchManualLocationChosen,
    manualLocationClear: dispatchClearManualLocation,
    isManualLocation,
    currentLocationPosition,
  };
};
